export const sectionStatus = ({ answered = 0, total = 0, pct = 0 }) => {
  if (answered === 0) return { kind: "not_started", label: "Not started", cls: "text-muted-foreground" };
  if (answered < total) return { kind: "in_progress", label: `In progress · ${answered}/${total}`, cls: "text-rag-amber" };
  return { kind: "complete", label: `${pct}%`, cls: null };
};

export const SCORING_NOTE = "How scoring works: practice confirmation (Met = 1, Needs attention = ½, Not met = 0) is blended 50/50 with the resident audit (Yes = 1, Partially = ½, No = 0; N/A excluded). Evidence recorded on the platform is shown for information and is never marked compliant automatically.";
